import { useLanguage } from "@/contexts/LanguageContext";
import { Globe } from "lucide-react";
import { useNavigate, useLocation } from "react-router-dom";

const routeMap: Record<string, { de: string; en: string }> = {
  "/imprint": { de: "/impressum", en: "/imprint" },
  "/impressum": { de: "/impressum", en: "/imprint" },
  "/privacy-policy": { de: "/datenschutz", en: "/privacy-policy" },
  "/datenschutz": { de: "/datenschutz", en: "/privacy-policy" },
  "/datenschutzerklaerung": { de: "/datenschutz", en: "/privacy-policy" },
  "/terms-of-service": { de: "/nutzungsbedingungen", en: "/terms-and-conditions" },
  "/terms-and-conditions": { de: "/nutzungsbedingungen", en: "/terms-and-conditions" },
  "/nutzungsbedingungen": { de: "/nutzungsbedingungen", en: "/terms-and-conditions" },
  "/right-of-withdrawal": { de: "/widerruf", en: "/right-of-withdrawal" },
  "/widerruf": { de: "/widerruf", en: "/right-of-withdrawal" },
  "/delete-account": { de: "/konto-loeschen", en: "/delete-account" },
  "/konto-loeschen": { de: "/konto-loeschen", en: "/delete-account" },
  "/data-export": { de: "/datenexport", en: "/data-export" },
  "/datenexport": { de: "/datenexport", en: "/data-export" },
};

const LanguageSwitcher = () => {
  const { language, setLanguage } = useLanguage();
  const navigate = useNavigate();
  const location = useLocation();

  const toggleLanguage = () => {
    const nextLang = language === "en" ? "de" : "en";
    setLanguage(nextLang);

    const currentPath = location.pathname;
    if (routeMap[currentPath]) {
      navigate(routeMap[currentPath][nextLang]);
    } else if (currentPath === "/" && nextLang === "en") {
      navigate("/en/");
    } else if (currentPath === "/en/" && nextLang === "de") {
      navigate("/");
    }
  };

  return (
    <button
      onClick={toggleLanguage}
      className="flex items-center gap-1.5 px-3 py-1.5 rounded-lg text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-secondary/50 transition-colors"
      aria-label="Switch language"
    >
      <Globe className="w-4 h-4" />
      <span className="uppercase">{language}</span>
    </button>
  );
};

export default LanguageSwitcher;
